import http from "../../utils/fetch";

export default {

    baseurl:'/api/swyl/v1/reform/reformMain',

    selecPage(query) {
        return http({
            url: this.baseurl+'/selectPage',
            method: 'post',
            params: query
        });
    },

    selectById(id,taskId){
        return http({
            url: this.baseurl+'/selectById',
            method: 'post',
            params: {id:id,taskId:taskId}
        });
    },
    xinghaojlSp(f) {
        return http({
            url: this.baseurl+'/xinghaojlSp',
            method: 'post',
            data: f
        });
    },
    otherSp(f){
        return http({
            url: this.baseurl+'/otherSp',
            method: 'post',
            data: f
        });
    },
    submit(f){
        return http({
            url: this.baseurl+'/submit',
            method: 'post',
            data: f
        });
    },


    deleteById(id){
        return http({
            url: this.baseurl+'/deleteById',
            method: 'post',
            params: {id:id}
        });
    },

    reformWidthdraw(data){
        return http({
            url: this.baseurl+'/withdrawReform',
            method: 'post',
            params: data
        });
    },

    reformCancel(data){
        return http({
            url: this.baseurl+'/cancelReform',
            method: 'post',
            params: data
        });
    },

    checkDownload(id){
        return http({
            url: this.baseurl+'/checkDownload',
            method: 'post',
            params: {id:id}
        });
    },
    xhZancun(data){
        return http({
            url: this.baseurl+'/xhZancun',
            method: 'post',
            data: data,
        })
    },
    getSupplier(code){
        return http.post(
            this.baseurl +'/getMaterialSupplier?materialCode=' + code
        );
    },
    getListByCode(data){
        return http({
            url: this.baseurl+'/getListByCode',
            method: 'post',
            params: data,
        })
    },
    getPurchaseGroup(code){
        return http.post(
            '/api/swyl/v1/mtlinfo/mdmPurchaseGroup/purchaseGroup?materialCode=' + code
        );
    },

    selecSapPage(query) {
        return http({
            url: '/api/swyl/v1/reform/reformMainSap/selectPage',
            method: 'post',
            params: query
        });
    },
    selecSapDetailPage(query) {
        return http({
            url: '/api/swyl/v1/reform/reformMainSap/selecSapDetail',
            method: 'post',
            params: query
        });
    },

    selecSapDetailSap(query) {
        return http({
            url: '/api/swyl/v1/reform/reformMainSap/selecSapDetailSap',
            method: 'post',
            params: query
        });
    },

    updateSapReform(query) {
        return http({
            url: '/api/swyl/v1/reform/reformMainSap/updateSapReform',
            method: 'post',
            data: query
        });
    },
    toSapReform(query) {
        return http({
            url: '/api/swyl/v1/reform/reformMainSap/toSapReform',
            method: 'post',
            data: query
        });
    },
    getSapReformEditionUtil(query) {
        return http({
            url: '/api/swyl/v1/reform/reformMainSap/getSapReformEditionUtil',
            method: 'post',
            data: query
        });
    },
    downloadExcelBom(query) {
        return http({
            url: '/api/swyl/v1/reform/reformMainSap/downloadExcelBom',
            method: 'get',
            params: query
        });
    },

    //改制样机
    selectProById(id,taskId){
        return http({
            url: '/api/swyl/v1/demo/reformMainPrototype/selectById',
            method: 'post',
            params: {id:id,taskId:taskId}
        });
    },

    xinghaojlTj(f) {
        return http({
            url: '/api/swyl/v1/demo/reformMainPrototype/xinghaojlTj',
            method: 'post',
            data: f
        });
    },
    otherSpPro(f) {
        return http({
            url: '/api/swyl/v1/demo/reformMainPrototype/otherSpPro',
            method: 'post',
            data: f
        });
    },

    selecProPage(query) {
        return http({
            url: '/api/swyl/v1/demo/reformMainPrototype/selectPage',
            method: 'post',
            params: query
        });
    },

    deleteProById(id){
        return http({
            url: '/api/swyl/v1/demo/reformMainPrototype/deleteById',
            method: 'post',
            params: {id:id}
        });
    },
    xhZancunPrototype(data){
        return http({
            url: '/api/swyl/v1/demo/reformMainPrototype/xhZancun',
            method: 'post',
            data: data,
        })
    },


}
